import { useMutation } from "react-query";
import { rejectTask } from "shared/taskState";
import * as notify from "shared/notify";

export const useRejectTask = () => {
    return useMutation(
        ({ taskKey, override, sourcePage, action }) => rejectTask(taskKey, override, sourcePage, action),
        {
            onSuccess: () => notify.success("Task has been rejected"),
        },
        {
            onError: () => notify.error("Task not rejected"),
        }
    );
};
